import { createIcon } from "../create-icon"

export const ImageDefaultIcon = createIcon({
  title: "ImageDefaultIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5zm4-6 1 1 3-4 5 7H6l3-4z"
      fill="currentColor"
    />
  ),
})

ImageDefaultIcon.displayName = "ImageDefaultIcon"
